import WOW from "wow.js";
import { closePopup, openPopup, toggleAnimation, listener } from "./quotePopup";
import singleProductRoute from "./productSingle";
import cartRoute from "./cart";
import checkoutRoute from "./woocommerceCheckout";

import Swiper, { Autoplay, Pagination, EffectFade } from "swiper";

export default {
  init() {
    console.log("Common.js init() started");

    // JavaScript to be fired on all pages
    $(".megaMenuTrigger").on("click", function () {
      $(this).toggleClass("menuOpen");
      $(".megaMenu").toggleClass("open");
    });

    // Expandable header search: first click reveals + focuses the input,
    // second click submits (only when there's a query). Clicking away closes.
    const $headerSearch = $("[data-header-search]");
    $headerSearch.find("[data-header-search-toggle]").on("click", function (e) {
      const $input = $headerSearch.find(".header-search__input");
      if (!$headerSearch.hasClass("is-open")) {
        e.preventDefault();
        $headerSearch.addClass("is-open");
        $input.focus();
      } else if (!$input.val().trim()) {
        e.preventDefault();
        $headerSearch.removeClass("is-open");
      }
      // else: has a query → allow the form to submit normally.
    });
    $(document).on("click", function (e) {
      if ($headerSearch.length && !$headerSearch[0].contains(e.target)) {
        $headerSearch.removeClass("is-open");
      }
    });

    const menuItems = [
      ".menu-our-products",
      ".menu-configurator",
      ".menu-fall-protection",
      ".menu-powerfeed",
      ".menu-mechanical-handling",
      ".menu-resources",
    ];

    menuItems.forEach((selector) => {
      $(selector)
        .find("a")
        .first()
        .append(
          '<p class="inline dropdown-chev text-white"><i class="fa fa-chevron-down"></i></p>'
        );
    });

    $("#mobileMegaTrigger").hover(
      function () {
        $(this).addClass("turnArrow");
      },
      function () {
        $(this).removeClass("turnArrow");
      }
    );

    setTimeout(function () {
      $(".quote-form-trigger-div").removeClass("startingPos");
    }, 5000);

    $(".filter-button").on("click", function () {
      $("#filter-container").toggleClass("hidden");
    });

    $(".quote-form-trigger").on("click", function () {
      $(".overlay").addClass("open").fadeToggle(1500);
      $(".quote-form-trigger-div").toggleClass("quote-open");
    });

    $(".overlay").on("click", function () {
      $(".quote-form-trigger-div").removeClass("quote-open");
      $(".overlay").fadeToggle(1500);
      setTimeout(function () {
        $(".overlay").removeClass("open");
      }, 1500);
    });

    $(".mobilemenutrigger").on("click", function () {
      $(".mobile-header").fadeToggle();
    });

    const mobileMenuDropdowns = ["handling", "fall-protection", "powerfeed"];

    mobileMenuDropdowns.forEach((dropdown) => {
      $("#mobileMegaTrigger-" + dropdown).on("click", function () {
        console.log("clicked:", dropdown);
        $(".mobile-mega-menu-" + dropdown).toggleClass("hidden");
      });
    });

    // $("#mobileMegaTrigger").on("click", function () {
    //   $(".mobile-mega-menu").toggleClass("hidden");
    // });

    var scrolled = false;
    $(window).on("scroll", function () {
      if (!scrolled) {
        scrolled = true;
        try {
          new WOW().init();
        } catch (e) {
          console.error("WOW.js error:", e);
        }
      }
    });

    // Swiper - wrapped in try/catch to prevent breaking other JS
    try {
      Swiper.use([Pagination, Autoplay, EffectFade]);

      // Only initialize if the element exists
      if (document.querySelector(".hero-swiper")) {
        new Swiper(".hero-swiper", {
          // Optional parameters
          slidesPerView: 1,
          loop: true,
          effect: "fade",
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
      console.log("Swiper initialized successfully");
    } catch (e) {
      console.error("Swiper initialization error:", e);
    }

    // Quote form toggle
    const quoteFormToggle = document.querySelector(".quote-form-toggle");
    console.log("Quote form toggle element:", quoteFormToggle);
    if (quoteFormToggle) {
      quoteFormToggle.addEventListener("click", (e) => {
        console.log("Quote form toggle clicked!");
        e.stopPropagation();

        const modal = document.querySelector(".quote-form-modal");
        const toggle = document.querySelector(".quote-form-toggle");
        const wrapper = document.querySelector(".quote-form-toggle-wrapper");
        const banner = document.querySelector(".banner");

        console.log("Elements found:", { modal, toggle, wrapper, banner });

        // indicates that the modal is open
        if (wrapper && wrapper.classList.contains("wrapper-open")) {
          document.removeEventListener("click", listener);
          if (modal && toggle && banner) {
            closePopup(wrapper, modal, toggle, banner);
          }
        } else if (wrapper) {
          // wrapper initialises as closed, so when its opened for the first time, add the listener
          document.addEventListener("click", listener);
          if (modal && banner) {
            openPopup(wrapper, modal, banner);
          }
        }
        if (toggle) {
          toggleAnimation(toggle);
        }
      });
    } else {
      console.log("Quote form toggle NOT found in DOM");
    }

    // PDP-specific bindings (gallery, qty stepper, tabs, FA check icons).
    // Run from common so we don't depend on the body-class router matching
    // WooCommerce's `single-product` class. The init is fully DOM-guarded.
    try {
      singleProductRoute.init();
    } catch (e) {
      console.error("PDP init error:", e);
    }

    // Cart drawer + add-to-cart intercept.
    // Must run on every page so the header `[data-cart-trigger="modal"]`
    // click opens the slide-out drawer everywhere, and so the PDP
    // add-to-cart AJAX intercept binds. The router key `cart` doesn't
    // match WC's `woocommerce-cart` body class, so the route was never
    // firing — same fix as the PDP route above. Init is DOM-guarded.
    try {
      cartRoute.init();
    } catch (e) {
      console.error("Cart drawer init error:", e);
    }

    // Checkout bindings (address toggle sync, Stripe appearance, place-order
    // icon). Same body-class-router insurance as the PDP/cart routes above.
    // Init is DOM-guarded and idempotent, so the router firing it too is fine.
    try {
      checkoutRoute.init();
    } catch (e) {
      console.error("Checkout init error:", e);
    }

    // Product Quote modal — global trigger. Used by:
    //   – PLP card "Request a Quote" buttons (per-card data-attrs)
    //   – PDP "Contact us for availability" / "Request a Quote" CTAs
    // Reads product context (name/SKU/URL) from each trigger and writes
    // those into the GF hidden inputs identified by their CSS classes
    // (.metreel-quote-field--{name,sku,url}) before opening the modal.
    const quoteModal = document.querySelector("[data-product-quote-modal]");
    if (quoteModal) {
      const subtitleEl = quoteModal.querySelector("[data-product-quote-subtitle]");
      const defaultSubtitle = subtitleEl ? subtitleEl.textContent : "";

      const setField = (selector, value) => {
        const wrapper = quoteModal.querySelector(selector);
        if (!wrapper) return;
        const input = wrapper.querySelector("input");
        if (input) input.value = value || "";
      };

      const productTitleEl = quoteModal.querySelector("[data-product-quote-product-title]");
      const productRowEl   = quoteModal.querySelector("[data-product-quote-product-row]");

      const openQuoteModal = (trigger) => {
        const productName = trigger.getAttribute("data-product-name") || "";

        // Push product context into the GF hidden fields.
        setField(".metreel-quote-field--name", productName);
        setField(".metreel-quote-field--sku",  trigger.getAttribute("data-product-sku"));
        setField(".metreel-quote-field--url",  trigger.getAttribute("data-product-url"));

        // Surface product name as a field-style row above the form.
        if (productTitleEl) productTitleEl.textContent = productName;
        if (productRowEl) productRowEl.classList.toggle("hidden", !productName);

        // Optional copy override.
        const subtitle = trigger.getAttribute("data-quote-subtitle");
        if (subtitleEl) {
          subtitleEl.textContent = subtitle || defaultSubtitle;
        }

        quoteModal.classList.remove("hidden");
        document.body.classList.add("overflow-hidden");
      };

      const closeQuoteModal = () => {
        quoteModal.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      };

      document.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-product-quote-trigger]");
        if (trigger) {
          e.preventDefault();
          openQuoteModal(trigger);
          return;
        }
        if (e.target.closest("[data-product-quote-close]")) {
          e.preventDefault();
          closeQuoteModal();
        }
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !quoteModal.classList.contains("hidden")) {
          closeQuoteModal();
        }
      });
    }

    // ── PLP Load More (custom AJAX, used when FacetWP isn't installed) ────────
    const loadMoreEl = document.querySelector(".plp-load-more");
    if (loadMoreEl && typeof window.metreelPlp !== "undefined") {
      const btn      = loadMoreEl.querySelector(".plp-load-more__btn");
      const status   = loadMoreEl.querySelector(".plp-load-more__status");
      const gridList = document.querySelector(".plp-grid ul.products");

      if (btn && gridList) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          const nextPage = parseInt(loadMoreEl.dataset.page, 10) + 1;
          const maxPage  = parseInt(loadMoreEl.dataset.max,  10);

          btn.disabled = true;
          if (status) status.classList.remove("hidden");

          const fd = new FormData();
          fd.append("action",   "metreel_plp_load_more");
          fd.append("nonce",    window.metreelPlp.nonce);
          fd.append("page",     String(nextPage));
          fd.append("per_page", loadMoreEl.dataset.perPage || "16");
          fd.append("term_id",  loadMoreEl.dataset.termId  || "0");
          fd.append("orderby",  loadMoreEl.dataset.orderby || "");

          fetch(window.metreelPlp.ajax_url, {
            method: "POST",
            credentials: "same-origin",
            body: fd,
          })
            .then((r) => r.json())
            .then((res) => {
              if (!res || !res.success) {
                throw new Error("Bad response");
              }
              if (res.data && res.data.html) {
                gridList.insertAdjacentHTML("beforeend", res.data.html);
              }
              loadMoreEl.dataset.page = String(nextPage);
              if (!res.data.has_more || nextPage >= maxPage) {
                loadMoreEl.remove();
              } else {
                btn.disabled = false;
                if (status) status.classList.add("hidden");
              }
            })
            .catch(() => {
              btn.disabled = false;
              if (status) {
                status.textContent = "Couldn't load more — please try again.";
                status.classList.remove("hidden");
              }
            });
        });
      }
    }
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js